import React from 'react';
import clsx from 'clsx';
import { object, string } from 'prop-types';

import MenuItem from '@material-ui/core/MenuItem';

import defaultClasses from './Autocomplete.module.css';

const GroupHeader = ({ children, classes }) => (
    <MenuItem
        classes={{
            root: clsx(
                defaultClasses.optGroupHeader,
                classes.root
            )
        }}
        disabled
    >
        {children}
    </MenuItem>
);

GroupHeader.defaultProps = {
    classes: {}
};

GroupHeader.propTypes = {
    classes:  object,
    children: string
};

export default GroupHeader;
